if (!customElements.get('article-contents-reveal')) {
  class ArticleContentsReveal extends HTMLElement {
    connectedCallback() {
      this.onScroll = this.onScroll.bind(this);
      document.addEventListener('theme:scroll', this.onScroll);
    }

    disconnectedCallback() {
      document.removeEventListener('theme:scroll', this.onScroll);
    }

    onScroll(event) {
      this.classList.toggle('is-visible', event.detail.position > 100);
    }
  }

  customElements.define('article-contents-reveal', ArticleContentsReveal);
}
